module.exports = __webpack_public_path__ + "img/lot-empt.e1ed38cd.png";